<mat-sidenav-container class="bank-list-container">
  <mat-sidenav mode="side" opened class="bank-sidenav">
    <div class="sidenav-header">
      <button mat-raised-button color="primary" class="add-bank-btn" (click)="addBank()">
        <mat-icon>add</mat-icon>
        Add Bank
      </button>
    </div>

    @if (loading()) {
      <div class="loading-spinner">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    } @else {
      @if (dataSource().length === 0) {
        <div class="no-data">
          No banks found. Click "Add Bank" to create one.
        </div>
      } @else {
        <mat-nav-list>
          @for (bank of dataSource(); track bank.id) {
            <a mat-list-item 
               [class.selected]="bankStore.selected()?.id === bank.id"
               (click)="selectBank(bank)">
              <mat-icon matListItemIcon>account_balance</mat-icon>
              <span matListItemTitle>{{bank.name}}</span>
            </a>
          }
        </mat-nav-list>
      }
    }
  </mat-sidenav>

  <mat-sidenav-content>
    @if (bankStore.selected()) {
      <!-- Loans View -->
      <div class="loans-container">
        <div class="controls-row">
          <div class="button-group">
            <button mat-raised-button color="primary" class="add-loan-btn" (click)="addLoan()">
              <mat-icon>add</mat-icon>
              Add Loan
            </button>
            <button mat-raised-button color="accent" (click)="editBank()">
              <mat-icon>edit</mat-icon>
              Edit Bank
            </button>
          </div>
        </div>

        @if (bankStore.selected()?.loans_collection?.length === 0 && !bankStore.selected()?.loc) {
          <div class="no-loans">
            <p>No loans found for this bank. Click "Add Loan" to create one.</p>
          </div>
        } @else {

          
          @for (st of states; track utilityService.trackByFn($index, st)) {
            @if (bankStore.getLoansByState(st)?.length || (st === 'active' && bankStore.selected()?.loc)) {
              <div class="section-header">
                <h2>{{utilityService.formatState(st)}} Loans</h2>
              </div>
              <div class="loan-cards-container">
                <!-- Personal Line of Credit Card (only in Active section) -->
                @if (st === 'active' && bankStore.selected()?.loc) {
                  <div class="loan-card">
                    <div class="loan-card-header">
                      <div class="loan-name">Personal Line of Credit</div>
                      <div class="loan-actions">
                        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Loan actions">
                          <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                          <button mat-menu-item (click)="fundLOC()">
                            <mat-icon>payment</mat-icon>
                            <span>Fund LOC</span>
                          </button>
                          <button mat-menu-item (click)="editBank()">
                            <mat-icon>edit</mat-icon>
                            <span>Edit</span>
                          </button>
                          <button mat-menu-item (click)="disableLoc()">
                            <mat-icon>delete</mat-icon>
                            <span>Disable</span>
                          </button>
                        </mat-menu>
                      </div>
                    </div>
                    <div class="loan-card-content">
                      <div class="loan-detail">
                        <span class="label">Current Balance:</span>
                        <span class="value">{{bankStore.selected()?.loc_balance | currency:'USD':'symbol':'1.2-2'}}</span>
                      </div>
                      <div class="loan-detail">
                        <span class="label">Interest Rate:</span>
                        <span class="value">{{bankStore.selected()?.loc_interest_rate}}%</span>
                      </div>
                      <div class="loan-detail">
                        <span class="label">Last Month's Interest:</span>
                        <span class="value">{{bankStore.selected()?.loc_interest | currency:'USD':'symbol':'1.2-2'}}</span>
                      </div>
                      <div class="loan-detail">
                        <span class="label">Total Interest Earned:</span>
                        <span class="value">{{bankStore.selected()?.loc_total_interest | currency:'USD':'symbol':'1.2-2'}}</span>
                      </div>
                    </div>
                  </div>
                }
                @for (loan of bankStore.getLoansByState(st); track loan.id) {
                  <div class="loan-card">
                    <div class="loan-card-header">
                      <div class="loan-name">{{loan.name}}</div>
                      <div class="loan-actions">
                        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Loan actions">
                          <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                          <button mat-menu-item (click)="recordLoanPayment(loan)">
                            <mat-icon>payment</mat-icon>
                            <span>Record Payment</span>
                          </button>
                          <button mat-menu-item (click)="editLoan(loan)">
                            <mat-icon>edit</mat-icon>
                            <span>Edit</span>
                          </button>
                          <button mat-menu-item (click)="deleteLoan(loan)">
                            <mat-icon>delete</mat-icon>
                            <span>Delete</span>
                          </button>
                          <button mat-menu-item (click)="viewAmortization(loan)">
                            <mat-icon>table_chart</mat-icon>
                            <span>Amortization</span>
                          </button>
                          <button mat-menu-item (click)="viewDocumentation(loan)">
                            <mat-icon>description</mat-icon>
                            <span>Documentation</span>
                          </button>
                        </mat-menu>
                      </div>
                    </div>
                    <div class="loan-card-content">
                      <div class="loan-detail">
                        <span class="label">Contact:</span>
                        <span class="value">{{get_name(loan.contact_id)}}</span>
                      </div>
                      <div class="loan-detail">
                        <span class="label">Amount:</span>
                        <span class="value">{{loan.amount | currency:'USD':'symbol':'1.2-2'}}</span>
                      </div>
                      <div class="loan-detail">
                        <span class="label">Interest Rate:</span>
                        <span class="value">{{loan.interest_rate}}%</span>
                      </div>
                      <div class="loan-detail">
                        <span class="label">Term:</span>
                        <span class="value">{{loan.term}} months</span>
                      </div>
                      <div class="loan-detail">
                        <span class="label">Payment:</span>
                        <span class="value">{{loan.payment | currency:'USD':'symbol':'1.2-2'}}</span>
                      </div>
                      <div class="loan-detail">
                        <span class="label">State:</span>
                        <span class="value state-badge" [ngClass]="'state-' + loan.state">
                          {{utilityService.formatState(loan.state)}}
                        </span>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          }
        }
      </div>

      <!-- Bank Register View -->
      <div class="register-section">
        <div class="section-header">
          <h2>Bank Register</h2>
        </div>
        <app-register></app-register>
      </div>
    } @else {
      <div class="no-selection w-full">
        <div class="empty-state-message">
          <p>Select a bank from the sidebar to view its loans.</p>
        </div>
      </div>
    }
  </mat-sidenav-content>
</mat-sidenav-container>
